// extracted by mini-css-extract-plugin
module.exports = {"header":"StartPageAlt_header__1QkMW"};